import { useEffect, useRef } from "preact/hooks";

export function useMount(effect: () => void) {
    const hasRun = useRef(false)
    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            effect();
        }
    }, []);
}
